import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '../config'

const trackerEntriesIncomeCollectionRef = collection(db, 'tracker_entries')

export async function getExpensesPerMonth(id, month, trackerEntries) {
  try {
    const data = await trackerEntries
    const filteredData = data?.filter(
      (t) =>
        t.data.trackerId === id &&
        t.data.month === month &&
        t.data.actual === false &&
        t.data.type === 'Expense'
    )

    let total = 0

    for (let doc in filteredData) {
      let monthlyData = filteredData[doc]
      total += monthlyData.data.amount
    }

    return total
  } catch (error) {
    console.log(error)
    return 0
  }
}
